<template>
  <v-dialog
    v-model="openModal"
    @click:outside="handleClose"
    max-width="800"
    class="ma-0"
  >
    <v-card flat tile height="363">
      <v-toolbar
        elevation="0"
        color="background"
        class="fluid-toolbar mb-0"
        height="64"
      >
        <v-toolbar-title
          :class="{
            'newTitle--text text-h6': !$vuetify.theme.dark,
          }"
          class="mr-2"
        >
          {{ $t('message.ai.aiWorkFlowChargeModal.title') }}
        </v-toolbar-title>
        <helper-tooltip :click="handleKnowMore" />

        <v-spacer></v-spacer>

        <v-toolbar-items>
          <v-btn icon @click="handleClose" class="no-ripple mdi-icon">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-subtitle
        class="ml-2"
        :class="{
          'textType--text text-body-1': !$vuetify.theme.dark,
        }"
        >{{ $t('message.ai.aiWorkFlowChargeModal.subtitle') }}</v-card-subtitle
      >

      <v-row justify="center" class="mt-1 align-center">
        <v-card flat width="610px" height="220px">
          <v-row justify="center" class="pt-3">
            <v-card
              flat
              class="mr-2 mb-2 custom-border"
              width="301px"
              height="106"
            >
              <v-card-title class="pt-3 pb-0 px-4 align-center">
                <span class="d-flex">
                  <simple-svg
                    :src="require('@/assets/mindMapModal.svg')"
                    width="24px"
                    height="24px"
                    fill-class-name="fill-color"
                    fill="#A0ACFF"
                  />
                  <p class="textType--text text-body-1 my-0 ml-2 text-bold">
                    {{ $t('message.ai.mindmap.mindmap') }}
                  </p>
                </span></v-card-title
              >

              <v-card-text
                class="pl-4 pr-0 pb-3 mt-2 textType2--text text-body-2"
                >{{
                  $t('message.ai.aiWorkFlowChargeModal.mindMapDescription')
                }}</v-card-text
              >
            </v-card>

            <v-card flat width="301px" height="106" class="custom-border">
              <v-card-title class="pt-3 pb-0 pl-4 pr-0 align-center">
                <span class="d-flex">
                  <simple-svg
                    :src="require('@/assets/ebookModal.svg')"
                    width="24px"
                    height="24px"
                    fill-class-name="fill-color"
                    fill="#A0ACFF"
                  />
                  <p class="textType--text text-body-1 ma-0 ml-2 text-bold">
                    {{ $t('message.ai.abstract.ebook') }}
                  </p>
                </span></v-card-title
              >

              <v-card-text
                class="pl-4 pr-2 mt-2 pb-3 textType2--text text-body-2"
                >{{
                  $t('message.ai.aiWorkFlowChargeModal.ebookDescription')
                }}</v-card-text
              >
            </v-card>
            <v-card flat class="mr-2 custom-border" width="301px" height="106">
              <v-card-title class="pt-3 pb-0 pl-4 pr-0 align-center">
                <span class="d-flex">
                  <v-icon color="#A0ACFF">mdi-help-box-multiple</v-icon>
                  <p class="textType--text text-body-1 my-0 ml-2 text-bold">
                    Quiz
                  </p>
                </span></v-card-title
              >

              <v-card-text
                class="pl-4 pr-2 mt-2 pb-0 textType2--text text-body-2"
                >{{
                  $t('message.ai.aiWorkFlowChargeModal.quizDescription')
                }}</v-card-text
              >
            </v-card>
            <v-card flat width="301px" height="106">
              <v-card-title></v-card-title>
              <v-card-text></v-card-text>
            </v-card>
          </v-row>
        </v-card>
      </v-row>
    </v-card>
    <v-row dense no-gutters class="mt-auto">
      <v-card flat tile height="auto" width="800" class="bg-color">
        <v-row align="center" justify="center">
          <v-col cols="auto">
            <v-card
              flat
              tile
              height="50"
              width="auto"
              class="d-flex align-center bg-color"
            >
              <div class="d-flex flex-row align-center align-items-center">
                <span
                  class="mr-2"
                  :class="{
                    'textType--text text-body-1': !$vuetify.theme.dark,
                  }"
                  >{{ $t('message.ai.aiWorkFlowChargeModal.aiCost') }}</span
                >
                <v-card width="18" height="18" flat class="mr-2 d-flex">
                  <v-img
                    src="@/assets/credit_small_icon.svg"
                    class="align-center bg-color-icon"
                  />
                </v-card>
                <span
                  class="text-body-1 line-height--fixed"
                  :class="{
                    'neutral--text': !$vuetify.theme.dark,
                  }"
                  >{{ aiWorkFlowPrice }}</span
                >
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div v-if="hasEnoughCredits">
          <v-col cols="12" class="pa-0 ma-0">
            <v-card flat class="bg-color bg-color-icon" height="95px">
              <credit-spend-card
                :amount="creditsBalance"
                :spendPrice="aiWorkFlowPrice"
                :subCalc="remainingCredits"
                parentModalKey="AiWorkFlowModal"
              />
            </v-card>
          </v-col>

          <v-col cols="12" class="pa-0 mb-2">
            <v-card flat class="bg-color">
              <div class="d-flex justify-center">
                <BaseBtn class="mx-2" type="secondary" @click="handleClose">{{
                  $t('message.actions.cancel')
                }}</BaseBtn>
                <BaseBtn
                  class="mx-2"
                  @click="generateAiWorkFlow"
                  :loading="isLoading"
                  :disabled="hasNoEnoughCredits"
                  >{{ $t('message.ai.aiWorkFlowChargeModal.confirm') }}</BaseBtn
                >
              </div>
            </v-card>
          </v-col>
        </div>
        <v-row v-else flat dense no-gutters class="mt-auto">
          <v-card flat tile height="166" width="800" class="bg-color">
            <empty-state
              :logoConfig="logoConfig"
              :arrowConfig="arrowConfig"
              :textConfig="textConfig"
            />
          </v-card>
        </v-row>
      </v-card>
    </v-row>
  </v-dialog>
</template>

<script>
import creditSpendCard from '@/components/CreditSpendCard.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import linkHelper from '@/utils/linkHelper.mixin.js'
import HelperTooltip from '@/components/HelperTooltip.vue'
import emptyState from '@/components/emptyState.vue'

export default {
  name: 'AiWorkFlowChargeModal',
  mixins: [linkHelper],
  components: {
    creditSpendCard,
    BaseBtn,
    HelperTooltip,
    emptyState,
  },

  props: {
    openModal: {
      type: Boolean,
      required: true,
    },
    aiWorkFlowCreditsBalance: {
      type: Object,
      required: true,
    },
    videoTime: {
      type: String,
      required: true,
    },
    aiWorkFlowCreated: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    aiWorkFlowPrice: 0,
    creditsBalance: 0,
    remainingCredits: 0,
    isLoading: false,
    hasNoEnoughCredits: false,
  }),
  computed: {
    logoConfig() {
      return {
        top: -73,
        left: 295,
        size: 0.5,
        rotation: 0,
      }
    },
    arrowConfig() {
      return {
        top: -35,
        left: 100,
        size: 0.65,
        rotation: 100,
      }
    },
    textConfig() {
      return {
        text: this.$i18next.t('message.ai.aiWorkFlowChargeModal.emptyState'),
        top: 85,
        left: 235,
        size: '1em',
        rotation: 0,
        textAlign: 'center',
        textWidth: '40%',
        hrefText: this.$i18next.t(
          'message.ai.aiWorkFlowChargeModal.addCredits'
        ),
        onClick: this.handleGoChargeCredits,
      }
    },
    hasEnoughCredits() {
      return !(this.remainingCredits < 0)
    },
  },
  watch: {
    aiWorkFlowCreditsBalance: {
      handler(balance) {
        this.aiWorkFlowPrice = balance.aiWorkFlowPrice
        this.creditsBalance = balance.creditsBalance
        this.remainingCredits = balance.remainingCredits
        if (this.remainingCredits < 0) {
          this.hasNoEnoughCredits = true
        }
      },
      deep: true,
    },
    aiWorkFlowCreated: function (val) {
      if (val) {
        this.isLoading = !val
        this.handleClose()
      }
    },
  },
  methods: {
    handleKnowMore() {
      const link = this.getAiHelperLink()
      window.open(link, '_blank')
    },
    handleClose() {
      this.$root.$emit('closeAiWorkFlowModal')
    },
    generateAiWorkFlow() {
      this.$root.$emit('generateAiWorkFlow')
      this.isLoading = true
    },
    handleGoChargeCredits() {
      this.handleClose()
      return this.$router.push({ name: 'Credits', query: { charge: 'true' } })
    },
  },
}
</script>
<style lang="scss" scoped>
.container__credit-spend {
  width: 400px;
  position: relative;
  left: 0;
  margin: auto;
}

.v-toolbar__items > .v-btn {
  border-radius: 0;
  height: 50% !important;
  max-height: none;
  margin-top: 17px;
}
.text-bold {
  font-weight: 500;
  font-size: 16px;
}

.custom-border {
  border: 1px solid var(--v-neutral-lighten3);
}

.mdi-icon {
  justify-content: end !important;
}
.bg-color {
  background-color: var(--v-newBackground-base) !important;
}
.card-height {
  height: auto !important;
}
.hide-card {
  visibility: hidden;
}
</style>

<style lang="scss">
.bg-color-icon {
  .v-image__image {
    background-color: var(--v-newBackground-base) !important;
  }
}
</style>
